// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Onk1","title":"AfterBackImages_title__2egN_","images":"AfterBackImages_images__1fM9P"};